import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import './body.scss';

const TextItem = styled(Paper)(({ theme, size }) => ({
    ...theme.typography[size],
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
}));

export default function Body() {

    return (
        <>
            <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
                className='firstDiv'
                >
                <div id="app">
                    <div class="titleFirst">
                        <div class="title-inner">
                            <div class="cafe">
                                <div class="cafe-inner">Contre le règlement encadrant les <strong>changements d'usage</strong> pour les meublés de tourisme Montpellierains</div>
                            </div>
                        </div>
                    </div>
                    <div class="image">
                        <img src='/perou.jpeg' alt='image' />
                    </div>
                </div>
            </Grid>
            <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="space-around"
                alignItems="center"
                style={{ backgroundColor: '#ede8e2', marginTop: '5vh' }}
            >
                <Grid item xs={12} md={7} className='descriptionTitle'>
                    Donnez votre avis, exprimez vous, pour faire vivre la démocratie locale!
                </Grid>
                <Grid xs={12} md={7} item className='descriptionText' sx={{fontSize: '2vh'}}>
                    <p>Nous protestons contre le règlement encadrant  <a href='https://www.montpellier3m.fr/logement-en-location-meublee-de-tourisme' target='_blank'>les changements d'usage</a> des locaux d'habitation réalisés sur le territoire de la ville de Montpellier.</p>
                    <p>En empêchant la mise en location de biens meublés de tourisme, la ville sanctionne ses citoyens mais également ses commerçants. </p>
                    <p>La location meublée touristique englobe aussi la location de courtes et moyennes durée pour une clientèle de passage au motif professionnel ou touristique.</p>
                </Grid>
                <Grid xs={12} md={7} item className='descriptionList' sx={{fontSize: '2vh'}}>
                    <p>Ce mode de location présente de nombreux atouts:</p>
                    <p><strong>Pour les commerces:</strong></p>
                    <p>La clientèle de passage qui y séjourne est consommatrice de biens et services  pour les commerces locaux.</p>
                    <p><strong>Pour les emplois:</strong></p>
                    <p>Cette activité génère de nombreux emplois (prestataires de services, gestionnaires….)</p>
                    <p><strong>Pour les citoyens: </strong></p>
                    <p>Elles donnent également la possibilité à des propriétaires de générer de nouveaux revenus dans une période économique aussi incertaine que celle de la COVID-19</p>
                    <p><strong>Pour l’image de la ville:</strong></p>
                    <p>Ce mode de séjour est devenu incontournable et répond aux besoins de nombreux voyageurs. L’ignorez et le restreindre aussi fortement au moment où le tourisme est à valoriser revient à marcher à contre courant. L’image d’une ville dynamique et attractive passe aussi par ses services d’hébergements.</p>
                    <p><strong>Pour l’économie Montpelliéraine:</strong></p>
                    <p>Les taxes de séjours collectées par ses locations permettent de moderniser nos infrastructures (tourisme, transports …).</p>
                    <p><strong>Pour le patrimoine immobilier:</strong></p>
                    <p>Cette source de revenue permet aux propriétaires de mieux entretenir leur bien, de valoriser leur patrimoine et de répondre à la demande croissante de rénovation des immeubles historiques de l’hyper centre.</p>
                </Grid>
                <Grid
                    container
                    spacing={2}
                    direction="row"
                    justifyContent="space-around"
                    alignItems="center"
                    style={{ backgroundColor: '#ede8e2', marginTop: '5vh' }}
                >
                    <h1 style={{textAlign: 'center'}}>Qui sommes-nous ?</h1>
                </Grid>
                <Grid
                    container
                    spacing={2}
                    direction="row"
                    justifyContent="space-around"
                    alignItems="center"
                    style={{ backgroundColor: '#ede8e2'}}
                >
                    <div class="person">
                        <div class="content">
                            <div class="content-inner">
                                <div class="circle" />
                                <img class="img img2" src='/person/auche.png' />
                            </div>
                        </div>
                        <div class="divider"></div>
                        <div class="name">Maître Christine AUCHÉ-HÉDOU</div>
                        <div class="title">Avocat Associé Cabinet Auché-Hédou</div>
                    </div>
                    <div class="person">
                        <div class="content">
                            <div class="content-inner">
                                <div class="circle" />
                                <img class="img img1" src='/person/berengere.png' />
                            </div>
                        </div>
                        <div class="divider"></div>
                        <div class="name">Bérengère BOUSCAREN</div>
                        <div class="title" style={{ textAlign: 'center' }}>Gérante de Class Appart, agence spécialisée en locations meublés courtes et moyennes durées, membre du SPLM </div>
                    </div>
                    <div class="person">
                        <div class="content">
                            <div class="content-inner">
                                <div class="circle" />
                                <img class="img img3" src='/person/lochard.png' />
                            </div>
                        </div>
                        <div class="divider"></div>
                        <div class="name">Jacqueline LOCHARD</div>
                        <div class="title" style={{ textAlign: 'center' }}>Gérante boutique Prêt à Porter Lily et Cachou</div>
                    </div>
                </Grid>
            </Grid>
        </>
    )
}